/**
 * Severity levels for application problems
 * Determines visual styling and priority ordering
 */
export enum ProblemSeverityEnum {
  /** Critical issues that prevent core functionality (e.g., API down, payment system unavailable) */
  CRITICAL = 'critical',
  /** Warning issues that may affect some functionality (e.g., printer offline, session expiring) */
  WARNING = 'warning',
  /** Informational issues (e.g., sync pending, minor service degradation) */
  INFO = 'info',
}
